import React from 'react';

const VideoSection = ({ title, subtitle, videoId, showCTA = false, onCTAClick }) => {
  return (
    <div className="bg-gradient-to-br from-green-50 to-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {(title || subtitle) && (
          <div className="text-center mb-10">
            {title && (
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                {subtitle}
              </p>
            )}
          </div>
        )}

        <div className="max-w-4xl mx-auto">
          {/* Video Container - Responsive YouTube Embed */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-green-500">
            <div className="aspect-w-9 aspect-h-16 md:aspect-w-16 md:aspect-h-9">
              <iframe
                className="w-full h-full"
                src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&controls=1`}
                title="MPillar AIQR Kit Product Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div>
          </div>

          {/* Video Stats/Features */}
          <div className="mt-8 grid md:grid-cols-3 gap-6 text-center">
            <div className="bg-white rounded-lg p-4 shadow-md">
              <div className="text-3xl mb-2">⚡</div>
              <p className="font-semibold text-gray-900">30 Sec Setup</p>
              <p className="text-sm text-gray-600">No tech knowledge needed</p>
            </div>
            <div className="bg-white rounded-lg p-4 shadow-md">
              <div className="text-3xl mb-2">📱</div>
              <p className="font-semibold text-gray-900">Works Instantly</p>
              <p className="text-sm text-gray-600">Customers scan & connect</p>
            </div>
            <div className="bg-white rounded-lg p-4 shadow-md">
              <div className="text-3xl mb-2">💰</div>
              <p className="font-semibold text-gray-900">Increase Sales</p>
              <p className="text-sm text-gray-600">40% more repeat business</p>
            </div>
          </div>

          {/* CTA Button */}
          {showCTA && onCTAClick && (
            <div className="mt-10 text-center">
              <button
                onClick={onCTAClick}
                className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-12 py-5 rounded-xl font-bold text-xl transition-all transform hover:scale-105 shadow-lg inline-flex items-center gap-3"
                data-testid="video-cta-button"
              >
                <span>🚀 Get Your AIQR Kit Now - ₹1,999</span>
              </button>
              <p className="text-sm text-gray-600 mt-4">
                ✓ 30-Day Money Back Guarantee | ✓ 500+ Happy Businesses
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VideoSection;
